import {protectedAxiosInstance} from "./AxiosInstance";

export const privateDocumentEndpoint = (uploadId) =>
  `/api/fileUpload/${encodeURIComponent(uploadId)}/content`;

export const fetchPrivateDocumentUrl = async (uploadId) => {
  if (!uploadId) throw new Error("Identifiant de document manquant");
  const response = await protectedAxiosInstance.get(
    privateDocumentEndpoint(uploadId),
    {responseType: "blob"},
  );
  return URL.createObjectURL(response.data);
};
